import { render } from "./PrimaryButton.vue?vue&type=template&id=94935892"
import script from "./PrimaryButton.vue?vue&type=script&lang=js"
export * from "./PrimaryButton.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/staging/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__